import { Box, Container, Stack } from '@mui/material';
import { useIsMobile } from '@vayufp/coast-components';
import { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { selectAllFeatureFlags } from '../../../../api/features';
import { SuccessChip } from '../../../../general/components/success-chip';
import { TestimonialPanel } from '../../../../general/components/testimonial-panel/TestimonialPanel';
import { WizardPage } from '../../../../general/components/wizard-page';
import { isEmbedded } from '../../../../utils';
import { sendTQC05 } from '../../../analytics/reducers/analytics-data';
import { sendCoastLoaded } from '../../../embedded/postMessage';
import { SetupAccountForm } from '../../components/setup-account-form';
import { getPromotion } from '../../reducer/promotion';

const enticementSx = {
  margin: 0.5,
};

const SetupAccountPage: FC = () => {
  const { search } = useLocation();
  const dispatch = useDispatch();
  const featureFlags = useSelector(selectAllFeatureFlags);

  const isMobile = useIsMobile();

  useEffect(() => {
    if (isEmbedded()) {
      sendCoastLoaded();
    }
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(search);
    const promoCode = params.get('promo');
    if (promoCode) {
      dispatch(getPromotion(promoCode));
    }

    if (featureFlags !== undefined) {
      dispatch(
        sendTQC05({
          testimonialPanelExperiment: featureFlags.bfcTestimonialPanelExperiment,
        }),
      );
    }
  }, [search, dispatch, featureFlags]);

  return (
    <Stack direction={isMobile ? 'column' : 'row'} height="100%" width="100%">
      <Box height="100%" width="100%">
        <WizardPage
          title="Start or resume an application"
          subtext={
            <>
              Start your application by entering your mobile phone and email.
              <br />
              Get a decision quickly in a few easy steps:
            </>
          }
          features={
            <>
              <Container maxWidth="xs" sx={{ textAlign: 'center' }} disableGutters>
                <SuccessChip size="small" label="Won't affect your personal credit" sx={enticementSx} />
                <SuccessChip size="small" label="No personal guarantee" sx={enticementSx} />
                <SuccessChip size="small" label="Apply in minutes" sx={enticementSx} />
                <SuccessChip size="small" label="Rewards and rebates" sx={enticementSx} />
              </Container>
            </>
          }
        >
          <SetupAccountForm />
        </WizardPage>
      </Box>
      {featureFlags?.bfcTestimonialPanelExperiment === 'cost-savings' && (
        <TestimonialPanel testimonialKey="cost-savings" />
      )}
      {featureFlags?.bfcTestimonialPanelExperiment === 'time-savings' && (
        <TestimonialPanel testimonialKey="time-savings" />
      )}
    </Stack>
  );
};

export { SetupAccountPage };
